// src/pages/Dashboard.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import Documents from "../sections/Documents";
import UploadForm from "../sections/UploadForm";
import AdminImports from "../sections/AdminImports";
import PowerbiLikeDashboard from "../sections/PowerbiLikeDashboard";
// import logoDR from "../img/logo-dataregion-mod-2.png";

export default function Dashboard() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const token = localStorage.getItem("token");
  const [view, setView] = useState("home");

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/login";
  };

  const roleLabel =
    user.role === "admin"
      ? "Administrador"
      : user.role === "institution"
      ? "Institución"
      : "Usuario";

  const initials = user.name ? user.name.charAt(0).toUpperCase() : "?";

  const [kpis, setKpis] = useState({
    users: 0,
    institutions: 0,
    documents: 0,
    loading: true,
  });

  useEffect(() => {
    if (!token) return;

    const fetchKPIs = async () => {
      try {
        setKpis((p) => ({ ...p, loading: true }));

        // 1) Usuarios (admins: usamos /api/users y filtramos roles)
        const usersRes = await axios.get("https://back.dataregion.com.co/api/users", {
          headers: { Authorization: "Bearer " + token },
        });

        const allUsers = Array.isArray(usersRes.data) ? usersRes.data : [];
        const institutionsCount = allUsers.filter((u) => u.role === "institution").length;
        const usersCount = allUsers.filter((u) => u.role === "user").length;

        // 2) Documentos (si /api/documents existe y requiere auth, lo usamos)
        let docsCount = 0;
        try {
          const r = await axios.get("https://back.dataregion.com.co/api/admin/kpis/documents-count", {
            headers: { Authorization: "Bearer " + token },
          });
          docsCount = Number(r.data?.count || 0);
        } catch (e) {
          console.error("Error docsCount KPI:", e.response?.status, e.response?.data || e.message);
          docsCount = 0;
        }

        setKpis({
          users: usersCount,
          institutions: institutionsCount,
          documents: docsCount,
          loading: false,
        });
      } catch (err) {
        console.error("Error cargando KPIs:", err);
        setKpis((p) => ({ ...p, loading: false }));
      }
    };

    fetchKPIs();
  }, [token]);

  return (
    <div className="dash-shell">
      {/* SIDEBAR */}
      <aside className="dash-sidebar">
        <div className="dash-sidebar-header">
          
        </div>

        <div className="dash-sidebar-user">
          <div className="user-avatar">{initials}</div>
          <div>
            <p className="user-name">{user.name}</p>
            <p className="user-role">{roleLabel}</p>
          </div>
        </div>

        <nav className="dash-menu">
          {user.role === "admin" && (
            <>
              <button
                className={`dash-menu-item ${view === "home" ? "active" : ""}`}
                onClick={() => setView("home")}
              >
                🏠 Inicio
              </button>
              <button
                className={`dash-menu-item ${
                  view === "create" ? "active" : ""
                }`}
                onClick={() => setView("create")}
              >
                ➕ Crear institución
              </button>
              <button
                className={`dash-menu-item ${
                  view === "institutions" ? "active" : ""
                }`}
                onClick={() => setView("institutions")}
              >
                🏫 Instituciones
              </button>
              <button
                className={`dash-menu-item ${
                  view === "users" ? "active" : ""
                }`}
                onClick={() => setView("users")}
              >
                👥 Usuarios Registrados
              </button>
              <button
                className={`dash-menu-item ${view === "imports" ? "active" : ""}`}
                onClick={() => setView("imports")}
              >
                📊 Cargar datos (Excel)
              </button>
              <button
                className={`dash-menu-item ${view === "docs" ? "active" : ""}`}
                onClick={() => setView("docs")}
              >
                📄 Documentos
              </button>

              <button
                className={`dash-menu-item ${view === "powerbi" ? "active" : ""}`}
                onClick={() => setView("powerbi")}
              >
                📊 Indicadores empresariales
              </button>
            </>
          )}

          {user.role === "institution" && (
            <button
              className={`dash-menu-item ${
                view === "upload" ? "active" : ""
              }`}
              onClick={() => setView("upload")}
            >
              📂 Subir documentos
            </button>
          )}

          {user.role === "user" && (
            <button
              className={`dash-menu-item ${
                view === "documents" ? "active" : ""
              }`}
              onClick={() => setView("documents")}
            >
              📄 Busqueda de Documentos
            </button>
          )}

          {user.role === "user" && (
            <button
              className={`dash-menu-item ${view === "powerbi" ? "active" : ""}`}
              onClick={() => setView("powerbi")}
            >
              📊 Indicadores empresariales
            </button>
          )}
        </nav>

        
      </aside>

      {/* MAIN */}
      <main className="dash-main">
        <header className="dash-main-header">
          <div>
            <h1>Tablero</h1>
            <p className="dash-greeting">
              Hola, <strong>{user.name}</strong>. Rol: {roleLabel} ({user.role})
            </p>
          </div>
        </header>

        <section className="dash-content">
  {/* HOME */}
  {view === "home" && (
    <>
      <div className="kpi-grid">
        {user.role === "admin" && (
          <>
            <KpiCard
              title="Usuarios"
              value={kpis.loading ? "—" : kpis.users}
              subtitle="Usuarios finales registrados"
              icon="👥"
            />
            <KpiCard
              title="Instituciones"
              value={kpis.loading ? "—" : kpis.institutions}
              subtitle="Cuentas institucionales"
              icon="🏫"
              accent
            />
            <KpiCard
              title="Documentos"
              value={kpis.loading ? "—" : kpis.documents}
              subtitle="Total de documentos"
              icon="📄"
            />
          </>
        )}

        {user.role === "institution" && (
          <KpiCard
            title="Mis documentos"
            value={kpis.loading ? "—" : kpis.documents}
            subtitle="Documentos subidos por tu institución"
            icon="📂"
            accent
          />
        )}

        {user.role === "user" && (
          <KpiCard
            title="Documentos"
            value={kpis.loading ? "—" : kpis.documents}
            subtitle="Disponibles para consulta"
            icon="🔎"
            accent
          />
        )}
      </div>

      <div className="dash-card">
        <h3>Bienvenido a DataRegión</h3>
        <p>Selecciona una opción del menú lateral para comenzar.</p>
      </div>
    </>
  )}

  {/* ADMIN: CREAR INSTITUCIÓN */}
  {user.role === "admin" && view === "create" && (
    <div className="dash-card">
      <CreateInstitutionForm token={token} />
    </div>
  )}

  {/* ADMIN: LISTA INSTITUCIONES */}
  {user.role === "admin" && view === "institutions" && (
    <div className="dash-card">
      <InstitutionList token={token} />
    </div>
  )}

  {/* ADMIN: LISTA USUARIOS */}
  {user.role === "admin" && view === "users" && (
    <div className="dash-card">
      <UserList token={token} />
    </div>
  )}

  {/* ADMIN: IMPORTS EXCEL */}
  {user.role === "admin" && view === "imports" && (
    <div className="dash-card">
      <AdminImports token={token} />
    </div>
  )}

  {/* ✅ ADMIN: DOCUMENTOS (ESTO FALTABA BIEN UBICADO) */}
  {user.role === "admin" && view === "docs" && (
    <div className="dash-card">
      <Top3 token={token} />
      {/* Si prefieres el top3 como antes, usa:
          <Top3 token={token} />
      */}
    </div>
  )}

  {/* ✅ ADMIN: POWERBI */}
  {user.role === "admin" && view === "powerbi" && (
    <div className="dash-card">
      <PowerbiLikeDashboard token={token} />
    </div>
  )}

  {/* INSTITUTION: UPLOAD */}
  {user.role === "institution" && view === "upload" && (
    <div className="dash-card">
      <UploadForm token={token} />
    </div>
  )}

  {/* USER: DOCUMENTS */}
  {user.role === "user" && view === "documents" && (
    <div className="dash-card">
      <Documents token={token} />
    </div>
  )}

  {/* USER: POWERBI */}
  {user.role === "user" && view === "powerbi" && (
    <div className="dash-card">
      <PowerbiLikeDashboard token={token} />
    </div>
  )}

  {/* SI AÚN USAS "top" */}
  {view === "top" && (
    <div className="dash-card">
      {user.role === "admin" && <Top3 token={token} />}
      {user.role === "institution" && <InstitutionDocuments token={token} />}
      {user.role === "user" && <Documents token={token} />}
    </div>
  )}
</section>
      </main>
    </div>
  );
}

function KpiCard({ title, value, subtitle, icon, accent }) {
  return (
    <div className={`kpi-card ${accent ? "accent" : ""}`}>
      <div className="kpi-left">
        <p className="kpi-title">{title}</p>
        <p className="kpi-value">{value}</p>
        <p className="kpi-subtitle">{subtitle}</p>
      </div>

      <div className="kpi-icon">{icon}</div>
    </div>
  );
}

/* === Componente: Listado de documentos (Top 3) === */
function Top3({ token }) {
  const [top, setTop] = useState([]);

  const loadTop = async () => {
    const r = await axios.get("https://back.dataregion.com.co/api/documents/top3", {
      headers: { Authorization: "Bearer " + token },
    });
    setTop(Array.isArray(r.data) ? r.data : []);
  };

  useEffect(() => {
    if (!token) return;
    loadTop().catch((err) => console.error("Error cargando top 3:", err));
    
  }, [token]);

  const handleDelete = async (id) => {
    const ok = window.confirm("¿Seguro que deseas eliminar este documento?");
    if (!ok) return;

    try {
      await axios.delete(`https://back.dataregion.com.co/api/documents/${id}`, {
        headers: { Authorization: "Bearer " + token },
      });
      setTop((prev) => prev.filter((d) => d.id !== id));
    } catch (err) {
      console.error("Error eliminando documento:", err);
      alert("❌ " + (err.response?.data?.message || err.message));
    }
  };

  return (
    <div className="institution-list">
      <h3>Listado de documentos subidos por instituciones</h3>

      {!top.length ? (
        <p className="small">No hay documentos aún.</p>
      ) : (
        <div className="table-wrapper">
          <table className="inst-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Título</th>
                <th>Institución</th>
                <th>Promedio ⭐</th>
                <th>Total calificaciones</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {top.map((t, i) => (
                <tr key={t.id}>
                  <td>{i + 1}</td>
                  <td>{t.title}</td>
                  <td>{t.institution || "—"}</td>
                  <td>{Number(t.avg || 0).toFixed(2)}</td>
                  <td>{t.count || 0}</td>
                  <td>
                    <button className="table-btn delete" onClick={() => handleDelete(t.id)}>
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}



/* === Componente: Crear institución === */
function CreateInstitutionForm({ token }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [contacto, setContacto] = useState("");
  const [cargo, setCargo] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    try {
      await axios.post(
        "https://back.dataregion.com.co/api/admin/create-institution",
        { name, email, password, contacto, cargo },
        { headers: { Authorization: "Bearer " + token } }
      );
      setMsg("✅ Institución creada correctamente");
      setName("");
      setEmail("");
      setPassword("");
      setContacto("");
      setCargo("");
    } catch (err) {
      setMsg("❌ Error: " + (err.response?.data?.message || err.message));
    }
  };

  return (
    <>
      <h3>Crear nueva institución</h3>
      <form onSubmit={handleSubmit} className="institution-form">
        <input
          type="text"
          placeholder="Nombre de la institución"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Nombre del contacto"
          value={contacto}
          onChange={(e) => setContacto(e.target.value)}
          required
        />

        <input
          type="text"
          placeholder="Cargo del contacto"
          value={cargo}
          onChange={(e) => setCargo(e.target.value)}
          required
        />
        <input
          type="email"
          placeholder="Correo"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="btn">
          Crear
        </button>
      </form>
      {msg && <p className="small">{msg}</p>}
    </>
  );
}

// === Componente: Listado de instituciones ===
function InstitutionList({ token }) {
  const [institutions, setInstitutions] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editPassword, setEditPassword] = useState("");  // << nuevo
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) return;

    const loadInstitutions = () => {
      axios
        .get("https://back.dataregion.com.co/api/users", {
          headers: { Authorization: "Bearer " + token },
        })
        .then((r) => {
          const filtered = r.data.filter((u) => u.role === "institution");
          setInstitutions(filtered);
        })
        .catch((err) => {
          console.error("Error cargando instituciones:", err);
        });
    };

    loadInstitutions();
  }, [token]);

  const startEdit = (inst) => {
    setEditingId(inst.id);
    setEditName(inst.name);
    setEditEmail(inst.email);
    setEditPassword("");      // vaciamos; solo cambia si el admin escribe
    setMsg("");
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditName("");
    setEditEmail("");
    setEditPassword("");
  };

  const handleUpdate = async (id) => {
    try {
      // armamos el payload
      const payload = {
        name: editName,
        email: editEmail,
      };
      if (editPassword.trim()) {
        payload.password = editPassword.trim();
      }

      await axios.put(
        `https://back.dataregion.com.co/api/admin/institution/${id}`,
        payload,
        { headers: { Authorization: "Bearer " + token } }
      );

      setMsg("✅ Institución actualizada correctamente");
      setEditingId(null);
      setEditPassword("");

      // recargar la lista
      const r = await axios.get("https://back.dataregion.com.co/api/users", {
        headers: { Authorization: "Bearer " + token },
      });
      const filtered = r.data.filter((u) => u.role === "institution");
      setInstitutions(filtered);
    } catch (err) {
      console.error(err);
      setMsg(
        "❌ Error al actualizar: " +
          (err.response?.data?.message || err.message)
      );
    }
  };

  const handleDelete = async (id) => {
    const ok = window.confirm(
      "¿Seguro que deseas eliminar esta institución?"
    );
    if (!ok) return;

    try {
      await axios.delete(
        `https://back.dataregion.com.co/api/admin/institution/${id}`,
        { headers: { Authorization: "Bearer " + token } }
      );
      setMsg("✅ Institución eliminada correctamente");
      setInstitutions((prev) => prev.filter((i) => i.id !== id));
    } catch (err) {
      console.error(err);
      setMsg(
        "❌ Error al eliminar: " +
          (err.response?.data?.message || err.message)
      );
    }
  };

  return (
    <div className="institution-list">
      <h3>Listado de instituciones</h3>
      {msg && <p className="small">{msg}</p>}

      {!institutions.length ? (
        <p>No hay instituciones registradas.</p>
      ) : (
        <div className="table-wrapper">
          <table className="inst-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Contacto</th>
                <th>Cargo</th>
                <th>Correo</th>
                <th>Contraseña</th>
                <th>Fecha de creación</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {institutions.map((inst) => (
                <tr key={inst.id}>
                  <td>{inst.id}</td>

                  <td>
                    {editingId === inst.id ? (
                      <input
                        value={editName}
                        onChange={(e) => setEditName(e.target.value)}
                      />
                    ) : (
                      inst.name
                    )}
                  </td>
                  <td>{inst.contacto || "—"}</td>
                  <td>{inst.cargo || "—"}</td>

                  <td>
                    {editingId === inst.id ? (
                      <input
                        value={editEmail}
                        onChange={(e) => setEditEmail(e.target.value)}
                      />
                    ) : (
                      inst.email
                    )}
                  </td>

                  {/* Campo contraseña: solo editable, nunca mostramos la real */}
                  <td>
                    {editingId === inst.id ? (
                      <input
                        type="password"
                        value={editPassword}
                        placeholder="Nueva contraseña"
                        onChange={(e) => setEditPassword(e.target.value)}
                      />
                    ) : (
                      "********"
                    )}
                  </td>

                  <td>{new Date(inst.createdAt).toLocaleString()}</td>

                  <td>
                    {editingId === inst.id ? (
                      <>
                        <button
                          className="table-btn save"
                          onClick={() => handleUpdate(inst.id)}
                        >
                          Guardar
                        </button>
                        <button
                          className="table-btn cancel"
                          onClick={cancelEdit}
                        >
                          Cancelar
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="table-btn edit"
                          onClick={() => startEdit(inst)}
                        >
                          Editar
                        </button>
                        <button
                          className="table-btn delete"
                          onClick={() => handleDelete(inst.id)}
                        >
                          Eliminar
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}



/* === Listado de usuarios finales === */
function UserList({ token }) {
  const [users, setUsers] = useState([]);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) return;

    axios
      .get("https://back.dataregion.com.co/api/users", {
        headers: { Authorization: "Bearer " + token },
      })
      .then((r) => {
        const filtered = r.data.filter((u) => u.role === "user");
        setUsers(filtered);
      })
      .catch((err) => {
        console.error("Error cargando usuarios:", err);
      });
  }, [token]);

  const handleDeleteUser = async (id) => {
    const ok = window.confirm(
      "¿Seguro que deseas eliminar este usuario?"
    );
    if (!ok) return;

    try {
      await axios.delete(
        `https://back.dataregion.com.co/api/admin/user/${id}`,
        { headers: { Authorization: "Bearer " + token } }
      );
      setMsg("✅ Usuario eliminado correctamente");
      setUsers((prev) => prev.filter((u) => u.id !== id));
    } catch (err) {
      console.error(err);
      setMsg(
        "❌ Error al eliminar: " +
          (err.response?.data?.message || err.message)
      );
    }
  };

  return (
    <>
      <h3>Listado de usuarios finales</h3>
      {msg && <p className="small">{msg}</p>}

      {!users.length ? (
        <p>No hay usuarios registrados.</p>
      ) : (
        <div className="table-wrapper">
          <table className="inst-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Tipo de usuario</th>
                <th>Correo</th>
                <th>Fecha de creación</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id}>
                  <td>{u.id}</td>
                  <td>{u.name}</td>
                  <td>{u.userType || "—"}</td>
                  <td>{u.email}</td>
                  <td>{new Date(u.createdAt).toLocaleString()}</td>
                  <td>
                    <button
                      className="table-btn delete"
                      onClick={() => handleDeleteUser(u.id)}
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

/* === Documentos propios de la institución logueada (CRUD básico) === */
function InstitutionDocuments({ token }) {
  const [docs, setDocs] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({
    title: "",
    tipoDocumento: "",
    descripcion: "",
    anoPublicacion: "",
    municipio: "",
    autores: "",
    entidad: "",
    categorias: "",
    palabrasClave: "",
  });
  const [msg, setMsg] = useState("");

  const loadDocs = async () => {
    try {
      const r = await axios.get("https://back.dataregion.com.co/api/documents", {
        headers: { Authorization: "Bearer " + token },
      });
      setDocs(r.data);
    } catch (err) {
      console.error("Error cargando documentos de la institución:", err);
      setMsg("❌ Error cargando documentos");
    }
  };

  useEffect(() => {
    if (!token) return;
    loadDocs();
  }, [token]);

  const startEdit = (doc) => {
    setEditingId(doc.id);
    setEditData({
      title: doc.title || "",
      tipoDocumento: doc.tipoDocumento || "",
      descripcion: doc.description || doc.descripcion || "",
      anoPublicacion: doc.anoPublicacion || "",
      municipio: doc.municipio || "",
      autores: doc.autores || "",
      entidad: doc.entidad || "",
      // si viene como array, lo convertimos a texto
      categorias: Array.isArray(doc.categorias)
        ? doc.categorias.join(", ")
        : doc.categorias || "",
      palabrasClave: doc.palabrasClave || "",
    });
    setMsg("");
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditData({
      title: "",
      tipoDocumento: "",
      descripcion: "",
      anoPublicacion: "",
      municipio: "",
      autores: "",
      entidad: "",
      categorias: "",
      palabrasClave: "",
    });
  };

  const handleEditChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  const handleUpdate = async (id) => {
    try {
      const payload = {
        title: editData.title,
        description: editData.descripcion,
        tipoDocumento: editData.tipoDocumento,
        anoPublicacion: editData.anoPublicacion,
        municipio: editData.municipio,
        autores: editData.autores,
        entidad: editData.entidad,
        // enviamos categorías como string separado por comas
        categorias: editData.categorias,
        palabrasClave: editData.palabrasClave,
      };

      await axios.put(
        `https://back.dataregion.com.co/api/documents/${id}`,
        payload,
        { headers: { Authorization: "Bearer " + token } }
      );

      setMsg("✅ Documento actualizado correctamente");
      setEditingId(null);
      await loadDocs();
    } catch (err) {
      console.error(err);
      setMsg(
        "❌ Error al actualizar: " +
          (err.response?.data?.message || err.message)
      );
    }
  };

  const handleDelete = async (id) => {
    const ok = window.confirm(
      "¿Seguro que deseas eliminar este documento?"
    );
    if (!ok) return;

    try {
      await axios.delete(`https://back.dataregion.com.co/api/documents/${id}`, {
        headers: { Authorization: "Bearer " + token },
      });
      setMsg("✅ Documento eliminado correctamente");
      setDocs((prev) => prev.filter((d) => d.id !== id));
    } catch (err) {
      console.error(err);
      setMsg(
        "❌ Error al eliminar: " +
          (err.response?.data?.message || err.message)
      );
    }
  };

  const renderCategorias = (d) => {
    if (Array.isArray(d.categorias)) return d.categorias.join(", ");
    return d.categorias || "";
  };

  return (
    <div className="institution-list">
      <h3>Listado de documentos propios</h3>
      {msg && <p className="small">{msg}</p>}

      {!docs.length ? (
        <p className="small">Tu institución aún no ha subido documentos.</p>
      ) : (
        <div className="table-wrapper">
          <table className="inst-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Título</th>
                <th>Tipo</th>
                <th>Año</th>
                <th>Municipio</th>
                <th>Autores</th>
                <th>Entidad</th>
                <th>Categorías</th>
                <th>Palabras clave</th>
                <th>Fecha de subida</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {docs.map((d, i) => {
                const isEditing = editingId === d.id;
                return (
                  <tr key={d.id}>
                    <td>{i + 1}</td>

                    {/* Título */}
                    <td>
                      {isEditing ? (
                        <input
                          value={editData.title}
                          onChange={(e) =>
                            handleEditChange("title", e.target.value)
                          }
                        />
                      ) : (
                        d.title
                      )}
                    </td>

                    {/* Tipo */}
                    <td>
                      {isEditing ? (
                        <input
                          value={editData.tipoDocumento}
                          onChange={(e) =>
                            handleEditChange("tipoDocumento", e.target.value)
                          }
                        />
                      ) : (
                        d.tipoDocumento
                      )}
                    </td>

                    {/* Año */}
                    <td>
                      {isEditing ? (
                        <input
                          value={editData.anoPublicacion}
                          onChange={(e) =>
                            handleEditChange("anoPublicacion", e.target.value)
                          }
                        />
                      ) : (
                        d.anoPublicacion
                      )}
                    </td>

                    {/* Municipio */}
                    <td>
                      {isEditing ? (
                        <input
                          value={editData.municipio}
                          onChange={(e) =>
                            handleEditChange("municipio", e.target.value)
                          }
                        />
                      ) : (
                        d.municipio
                      )}
                    </td>

                    {/* Autores */}
                    <td>
                      {isEditing ? (
                        <input
                          value={editData.autores}
                          onChange={(e) =>
                            handleEditChange("autores", e.target.value)
                          }
                        />
                      ) : (
                        d.autores
                      )}
                    </td>

                    {/* Entidad */}
                    <td>
                      {isEditing ? (
                        <input
                          value={editData.entidad}
                          onChange={(e) =>
                            handleEditChange("entidad", e.target.value)
                          }
                        />
                      ) : (
                        d.entidad
                      )}
                    </td>

                    {/* Categorías */}
                    <td>
                      {isEditing ? (
                        <input
                          value={editData.categorias}
                          onChange={(e) =>
                            handleEditChange("categorias", e.target.value)
                          }
                          placeholder="Separadas por coma"
                        />
                      ) : (
                        renderCategorias(d)
                      )}
                    </td>

                    {/* Palabras clave */}
                    <td>
                      {isEditing ? (
                        <input
                          value={editData.palabrasClave}
                          onChange={(e) =>
                            handleEditChange("palabrasClave", e.target.value)
                          }
                        />
                      ) : (
                        d.palabrasClave
                      )}
                    </td>

                    {/* Fecha */}
                    <td>{new Date(d.createdAt).toLocaleString()}</td>

                    {/* Acciones */}
                    <td>
                      {isEditing ? (
                        <>
                          <button
                            className="table-btn save"
                            onClick={() => handleUpdate(d.id)}
                          >
                            Guardar
                          </button>
                          <button
                            className="table-btn cancel"
                            onClick={cancelEdit}
                          >
                            Cancelar
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="table-btn edit"
                            onClick={() => startEdit(d)}
                          >
                            Editar
                          </button>
                          <button
                            className="table-btn delete"
                            onClick={() => handleDelete(d.id)}
                          >
                            Eliminar
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}



